export const tools = {
  parseDouble,
  parseDoubleToString,
  formatDate,
  parseDate,
  splitDateTime,
  splitHoursMinutes,
  pickupToTimewindowsToString,
  uriEncodeString,
  logAxios
};

function parseDouble(val) {
  let stringVal = val + "";
  //force removal of dot as decimal seperator
  if (stringVal && stringVal.length > 0 && stringVal.includes(".")) {
    if (stringVal.length - stringVal.indexOf(".") > 3) {
      stringVal = stringVal.replace(".", "");
    } else {
      stringVal = stringVal.replace(".", ",");
    }
  }
  const numericVal = stringVal.replace(/[^0-9,]/g, "").replace(",", ".");
  const doubleVal = parseFloat(numericVal != "" ? numericVal : 0);
  return isNaN(doubleVal) ? 0.0 : doubleVal;
}

function parseDoubleToString(val) {
  return Number(val.toFixed(2)).toLocaleString("dk", {
    minimumFractionDigits: 2
  });
}

function formatDate(date) {
  if (!date) {
    return null;
  }
  const [year, month, day] = date.split("-");
  return `${day}-${month}-${year}`;
}

function parseDate(date) {
  if (!date) {
    return null;
  }
  const [day, month, year] = date.split("-");
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}

function splitDateTime(datetime) {
  const d = new Date(
    datetime.getTime() + -1 * datetime.getTimezoneOffset() * 60 * 1000
  );

  const date = d.toISOString().substr(0, 10);
  const time = d.toISOString().substr(11, 5);

  return { date, time };
}

function splitHoursMinutes(timestamp) {
  const hours = timestamp.substr(0, 2);
  const minutes = timestamp.substr(3, 2);

  return { hours, minutes };
}

function pickupToTimewindowsToString(timestamp) {
  return timestamp && timestamp.to
    ? tools.splitDateTime(new Date(timestamp.to)).time +
        (timestamp.comment != "" ? " (" + timestamp.comment + ")" : "")
    : "";
}

function uriEncodeString(str) {
  // return encodeURI(str);
  return str; // do nothing!!!
}

function logAxios(url, body, requestOptions) {
  console.log(url);
  console.log(body);
  console.log(requestOptions);
}
